module.exports = __webpack_public_path__ + "img/postcard-icon.39de36ef.svg";